import React, { useEffect, useRef, useState } from "react";
import * as OrderActionsAsync from "store/order/orderAsyncThunk";
import * as OrderActions from "store/order/orderSlice";
import * as OrderSelectors from "store/order/orderSelectors";
import * as ProjectSelectors from "store/project/projectSelectros";
import { useDispatch, useSelector } from "react-redux";
import {
  useCalcSelectors,
  useEventEmitter,
  useHeaderSize,
  useScrollTo,
} from "hooks";
import Recaptcha from "react-recaptcha";
import Form from "rsuite/Form";
import Message from "rsuite/Message";
import FormControlUploadFiles from "components/Commons/FormControlUpload";
import VALIDATION_MODEL, { VALIDATION_MODEL_ESTIMATE } from "./validation";
import FieldText from "../../Commons/FieldText";
import FieldTextarea from "../../Commons/FieldTextarea";
import FieldCheckbox from "../../Commons/FieldCheckbox";
import CartFooter, { isPromoCodeTextOk } from "../../Cart/CartFooter";
import axios from "axios";
import * as ProjectActions from "../../../store/project/projectSlice";
import { isPromoCode } from "../../Cart";

export { isEstimateTab };
export { isNewCustomer };
export { isPromoCodeVisible };

let recaptchaInstance;
let isEstimateTab = false;
let isNewCustomer = true;
let isPromoCodeVisible = false;

let isEmailError = false;

export default function PageForm() {
  const { getTotalPrice, getEta } = useCalcSelectors();
  const projectTypeActive = useSelector(
    ProjectSelectors.selectProjectsTypeActive
  );
  const orderErrors = useSelector(OrderSelectors.selectOrderErrors);
  const orderErrorsRef = useRef();
  const orderInformation = useSelector(OrderSelectors.selectOrderInformation);
  const orderUserIsPredefined = useSelector(
    OrderSelectors.selectInformationIsDisabled
  );
  const formRef = useRef();
  const checkboxConsentProcessingRef = useRef();
  const checkboxShowcaseProjectRef = useRef();
  const captchaLoadedRef = useRef();
  const [captchaLoaded, setCaptchaLoaded] = useState(false);
  const [headerSize] = useHeaderSize();
  const { scrollTo } = useScrollTo();
  const events = useEventEmitter();
  const dispatch = useDispatch();

  // for cart footer for separate page begin
  const projectTypeActiveHash = useSelector(
    ProjectSelectors.selectProjectsTypeActiveHash
  );
  const projectKey = `${projectTypeActive}${projectTypeActiveHash}`;
  const optionsPagesIsExists = useSelector(
    ProjectSelectors.selectOptionsPagesIsExists
  );
  const optionsPages = useSelector(ProjectSelectors.selectOptionsPages);

  const eta = useSelector(getEta(projectKey));
  const checklist = useSelector(ProjectSelectors.selectChecklist);
  const payments = useSelector(ProjectSelectors.selectPayments);
  const pagesIsNotExists = !optionsPagesIsExists && optionsPages.length === 0;
  const pagesIsExists = optionsPagesIsExists && optionsPages.length > 0;
  const total = useSelector(getTotalPrice(projectKey));
  const optionsWithPrice = useSelector(ProjectSelectors.selectOptionsWithPrice);

  const projectDetails = useSelector(ProjectSelectors.selectProjectDetails);

  const [isEstTab, setIsEstTab] = useState(false);
  // for cart footer for separate page end

  const captchaExecute = () => {
    //add class for styling recaptcha window begin
    const captchaIframe = document.querySelector('iframe[title^="recaptcha"]');
    if (captchaIframe !== null) {
      captchaIframe.closest("div").classList.add("app-recaptcha-wrapper");
    }
    //add class for styling recaptcha window end

    captchaLoadedRef.current && recaptchaInstance.execute();
  };

  const captchaReset = () => {
    captchaLoadedRef.current && recaptchaInstance.reset();
  };

  const handleSetFormValues = (value) => {
    dispatch(OrderActions.setOrderInformation(value));
  };

  const handleSetFormValuesErrors = (errors) => {
    if (errors.email) {
      isEmailError = true;
    } else {
      isEmailError = false;
    }
    dispatch(OrderActions.setOrderInformationErrors(errors));
  };

  const handleSubmit = () => {
    if (formRef && formRef.current && !formRef.current.check()) {
      const elementForm = formRef.current.root;
      elementForm.classList.add("is-submit-clicked");
      const elementOffset = headerSize.height;
      scrollTo(elementForm, elementOffset);
      captchaReset();
      return false;
    }

    if (orderErrorsRef.current?.error === true) {
      captchaReset();
    }

    /*hardcode for captcha not download begin*/
    const captchaIframe = document.querySelector('iframe[title^="recaptcha"]');
    captchaLoadedRef.current && captchaIframe
      ? captchaExecute()
      : handleVerifyCallback();
    /*hardcode for captcha not download end*/

    // captchaLoadedRef.current ? captchaExecute() : handleVerifyCallback();
  };

  const handleChange = ({ name }) => {
    switch (name) {
      case "isConsentProcessing":
        checkboxConsentProcessingRef.current
          ?.querySelector(`input[name="isConsentProcessing"]`)
          .click();
        break;
      case "isShowcaseProject":
        checkboxShowcaseProjectRef.current
          ?.querySelector(`input[name="isShowcaseProject"]`)
          .click();
        break;
      default:
        break;
    }
  };

  const handleVerifyCallback = (response) => {
    setTimeout(() => {
      dispatch(OrderActionsAsync.sendOrder(response));
    }, 0);
  };

  const clickOnTab = (isEstimateTabActive) => {
    setIsEstTab((current) => isEstimateTabActive);
    isEstimateTabActive ? (isEstimateTab = true) : (isEstimateTab = false);
  };

  const [promocodeCount, setPromocodeCount] = useState(0);

  const onEmailChanged = (value) => {
    if (!isPromoCodeVisible || value.trim().length < 1 || isEmailError) {
      return;
    }
    sendEmail(value);
  };

  const sendEmail = async (email) => {
    try {
      const params = new URLSearchParams();
      params.append("email", email);

      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      const response = await axios.post(
        "/order-check-email.html",
        params.toString(),
        config
      );
      isNewCustomer = !response.data;
      if (isPromoCodeTextOk && isNewCustomer) {
        isPromoCode = true;
      } else {
        isPromoCode = false;
      }
      dispatch(ProjectActions.setChecklistOptions(email));
      dispatch(ProjectActions.setChecklistOptionsChecked());
      dispatch(ProjectActions.setChecklistOptionsDisabled());
      setPromocodeCount(promocodeCount + 1);
    } catch (error) {
      console.error(error);
    }
  };

  function checkPromoCodeVisibility() {
    if (projectDetails.isPromoCodeVisible) {
      if (projectDetails.isPromoCodeVisibleTab === undefined) {
        isPromoCodeVisible = true;
      } else if (
        projectDetails.isPromoCodeVisibleTab === projectTypeActiveHash
      ) {
        isPromoCodeVisible = true;
      } else {
        isPromoCodeVisible = false;
      }
    } else {
      isPromoCodeVisible = false;
    }
  }

  checkPromoCodeVisibility();

  if (promocodeCount < 1) {
    onEmailChanged(orderInformation.email);
  }

  useEffect(() => {
    const allWithClass = Array.from(
      document.querySelectorAll(".app-tab-item-link")
    );

    allWithClass.forEach((element) => {
      element.addEventListener("click", function () {
        setPromocodeCount(0);
      });
    });
  }, []);

  useEffect(() => {
    events.on("Form:Submit", handleSubmit);
    events.on("Form:Change", handleChange);

    return () => {
      events.off("Form:Submit", handleSubmit);
      events.off("Form:Change", handleChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    orderErrorsRef.current = orderErrors;
  }, [orderErrors]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const captchaKey = window["recaptcha_key"];
      const captchaKeyExists = !!(captchaKey && captchaKey.length > 5);
      setCaptchaLoaded(captchaKeyExists);
      captchaLoadedRef.current = captchaKeyExists;
    }, 1000);

    return () => {
      const prevCaptcha = document.querySelector('iframe[title^="recaptcha"]');
      if (prevCaptcha) {
        prevCaptcha?.parentNode?.parentNode?.remove();
      }
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className={`app-form ${
        projectDetails.isCalculationPage ? "app-form--tabs" : ""
      }`}
    >
      {projectDetails.isCalculationPage && (
        <div className="app-form-tab-list">
          <div
            className={`app-form-tab-item ${isEstTab ? "is-active" : ""}`}
            onClick={() => clickOnTab(true)}
          >
            Email This Estimate
          </div>
          <div
            className={`app-form-tab-item ${isEstTab ? "" : "is-active"}`}
            onClick={() => clickOnTab(false)}
          >
            Start Your Project
          </div>
        </div>
      )}
      <Form
        fluid
        ref={formRef}
        formValue={orderInformation}
        model={isEstTab ? VALIDATION_MODEL_ESTIMATE : VALIDATION_MODEL}
        onChange={handleSetFormValues}
        onCheck={handleSetFormValuesErrors}
      >
        {projectDetails.isButtonOnTheLeft && (
          <div className="app-form-row">
            <div className="app-form-cell">
              <div className="app-form-description">
                {isEstTab
                  ? "Want to keep this estimate for a closer review? Enter your email address, hit the button below, and we’ll send it right to your inbox."
                  : "Want us to begin working on your project straight away? Complete the form and submit your designs and/or requirements."}
              </div>
            </div>
          </div>
        )}
        <div className="app-form-row">
          <div className="app-form-cell">
            <h3 className="app-form-title">
              {isEstTab ? "Name Your Project" : "Project brief"}
            </h3>

            <FieldTextarea
              name="textarea"
              placeholder={
                isEstTab
                  ? "Name Your Project *"
                  : `Specify your ${
                      projectDetails.projectName
                        ? projectDetails.projectName
                        : projectTypeActive
                    } project details *`
              }
              required={true}
              numberRows={isEstTab ? 1 : 3}
            />
          </div>
        </div>
        <div
          className={
            isEstTab
              ? "app-form-row app-form-row--two-contacts"
              : "app-form-row-two"
          }
        >
          {!isEstTab && (
            <div className="app-form-cell">
              <h3 className="app-form-title">Attachments</h3>
              <FormControlUploadFiles />
            </div>
          )}
          <div className="app-form-cell">
            <h3 className="app-form-title">Contact details</h3>
            <FieldText
              disabled={orderUserIsPredefined?.name}
              label="Name"
              name="name"
              placeholder="Name *"
              required={true}
            />
            {!isEstTab && (
              <FieldText
                disabled={orderUserIsPredefined?.phone}
                label="Phone"
                name="phone"
                placeholder="Phone *"
                required={true}
              />
            )}
            <FieldText
              disabled={orderUserIsPredefined?.email}
              label="Email"
              name="email"
              placeholder="Email *"
              required={true}
              type="email"
              onChange={onEmailChanged}
            />
            <FieldCheckbox
              ref={checkboxConsentProcessingRef}
              name="isConsentProcessing"
              checked={orderInformation.isConsentProcessing}
              style={{ display: "none" }}
            />
            <FieldCheckbox
              ref={checkboxShowcaseProjectRef}
              name="isShowcaseProject"
              checked={orderInformation.isShowcaseProject}
              style={{ display: "none" }}
            />
          </div>
        </div>
        {projectDetails.isButtonOnTheLeft && (
          <CartFooter
            eta={eta}
            checklist={checklist}
            payments={payments}
            total={total}
            pagesIsNotExists={pagesIsNotExists}
            optionsWithPrice={optionsWithPrice}
            pagesIsExists={pagesIsExists}
            isButtonOnLeft={projectDetails.isButtonOnTheLeft}
            buttonText={isEstTab ? "Email This Estimate" : "Start Your Project"}
          />
        )}

        {orderErrors.error && (
          <Message type="error">{orderErrors.message}</Message>
        )}
      </Form>
      {captchaLoaded && (
        <Recaptcha
          ref={(e) => (recaptchaInstance = e)}
          badge="bottomleft"
          sitekey={window["recaptcha_key"]}
          size="invisible"
          verifyCallback={handleVerifyCallback}
        />
      )}
    </div>
  );
}
